import 'react-app-polyfill/ie9';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Provider } from 'react-redux';
import 'styles/css/index.css';
import App from 'js/components/App';
import { store, persistor } from 'js/core/configureStore';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { ToastContainer } from 'react-toastify';
import { I18nextProvider } from 'react-i18next';
import i18n from './js/i18n';

const triiboTheme = createTheme({
  palette: {
    primary: {
      main: '#6E3296',
    },
    secondary: {
      main: '#8B8B8B',
    },
  },
  typography: {
    useNextVariants: true,
    fontFamily: ['Source Sans Pro', 'sans-serif'].join(','),
    fontSize: 15,
    color: {
      primary: '#6E3296',
      secondary: '#707070',
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('triibo-web-app'));

root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <BrowserRouter>
        <ThemeProvider theme={triiboTheme}>
          <I18nextProvider i18n={i18n}>
            <ToastContainer autoClose={4000} />
            <App />
          </I18nextProvider>
        </ThemeProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>
);
